
export default {
    props: {
        geo: {
            type: String,
            required: true,
        },
        disableLine: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        /** @return {string[]} */
        availableLangs() {
            /** @type {string[]} */
            const langs = [];
            for (const locale of this.$i18n.locales) {
                langs.push(typeof(locale) === 'string' ? locale : locale.lang);
            }
            return langs;
        },
    },
    methods: {
        /**
         * @param {string} translationKey
         * @return {string} The translation.
         */
        getTranslation(translationKey) {
            return this.$t(`webCommon.footer.${translationKey}`);
        },
        /**
         * @param {string} locale The locale
         */
        onLanguageChanged(locale) {
            // i18n local is set in app/middleware/locale.js
            this.$i18n.setLocale(locale);
            if (this.$route.query.lang) {
                const query = { ...this.$route.query, lang: undefined };
                this.$router.replace({ query });
            }
        },
    },
};
